import { List, FocusZone } from 'office-ui-fabric-react';
import PropTypes from 'prop-types';
import React from 'react';

import './BrandfolderList.css';

class BrandfolderList extends React.Component {
  static propTypes = {
    containers: PropTypes.array,
    onClick: PropTypes.func.isRequired
  };

  render() {
    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <FocusZone>
            <List
              className="brandfolder-list"
              items={this.props.containers}
              onRenderCell={this.onRenderCell}
              getItemCountForPage={this.containerCount}
            />
          </FocusZone>
        </div>
      </div>
    );
  }

  containerCount = () => {
    return this.props.containers.length;
  }

  onRenderCell = (item, index) => {
    return (
      <div className="ms-Grid-col ms-xs12 ms-sm12 ms-lg6 ms-xl4">
        <div
          data-is-focusable={true}
          className="brandfolder-list-item"
          onClick={() => this.props.onClick(item)}
        >
          <div className="image-container">
            {item.attributes.card_image &&
              item.attributes.card_image.length > 0 && (
                <img
                  src={item.attributes.card_image}
                  className="image"
                  alt={item.attributes.name}
                />
              )}
            {!item.attributes.card_image && (
              <i className="ms-Icon ms-Icon--PictureFill no-image" aria-hidden="true" />
            )}
          </div>
          <div className="name">
            <a>{item.attributes.name}</a>
          </div>
        </div>
      </div>
    );
  };
}

export default BrandfolderList;



// WEBPACK FOOTER //
// ./src/components/BrandfolderList/BrandfolderList.js